import React from 'react';
import { DropdownTemplate } from 'themes/components';

export default function Dropdown(props) {
    return <DropdownTemplate {...props} />
}